<span class="{{cssClass}}" *ngIf="passenger">
  {{ passenger.name.first }} {{ passenger.name.last}}
</span>